import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import type { PageLayoutStore } from 'shared/layout'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IResponseFullSurvey } from 'entities/Surveys/api/types'
import { SurveyCreateStore } from 'pages/surveys/ui/SurveyView/store/surveyCreateStore'
import { SurveyViewUi } from 'pages/surveys/ui/SurveyView/ui/SurveyViewUi'

type ISurveyViewProps = {
  pageLayoutStore: PageLayoutStore
  response?: IResponseFullSurvey
}

export const SurveyView = observer(({ pageLayoutStore, response }: ISurveyViewProps) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new SurveyCreateStore(entities, response?.id ?? undefined))

  useEffect(() => {
    void entities.complianceStore.fetchOrganizationBusinessProfile()
    if (response) void store.init(response)
    return () => store.dispose()
  }, [])

  return <SurveyViewUi store={store} pageLayoutStore={pageLayoutStore} />
})
